import { createRoot } from 'react-dom/client';
import App from './components/templates/App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);

reportWebVitals();
